import type { QuestionChoice } from '@mentimeter/legacy-series-types/common';
import type {
  CompatibilityInteractiveContent,
  CompatibilitySlide,
} from '../../../compatibility-types';
import { getOrSetCache, type WithCache } from '../../../utils/get-or-set-cache';
import { choiceToQuestionChoice } from '../../converters/interactive-content';

export function getCachedChoicesProperty(
  slide: CompatibilitySlide,
  interactiveContent: CompatibilityInteractiveContent,
) {
  const choices: Array<QuestionChoice> =
    interactiveContent.choices?.map((c, i) => ({
      ...choiceToQuestionChoice(c),
      id: c.legacyChoiceId ?? i + 1,
      position: i,
    })) ?? [];

  const cacheKey = JSON.stringify(choices);
  return getOrSetCache(
    slide as WithCache<CompatibilitySlide>,
    'choices',
    cacheKey,
    choices,
  );
}
